import { ConstantsTableColsWindRichtlinienab } from "./constants-table-cols-wind-richtlinienab";

export class ConstantsTableColsErgebnisWindRichtlinienab extends ConstantsTableColsWindRichtlinienab{ 
    static readonly RM: string = 'RM';
    static readonly GEWICHTUNGSFAKTOR: string = 'GEWICHTUNGSFAKTOR';
    static readonly RM_STRICH: string = 'RM_STRICH';

    public static override getColumns(): string[]
    {
      return [ 
        this.WINDRICHTUNG + '_' + this.TRANSPORTRICHTUNG + '_' + this.BESCHREIBUNG,
        this.WINDHAEUFIGKEIT,
        this.GEBIETSKATEGORIE,
        this.ZUL_GERUCHSTUND_GIRL,
        this.RM,
        this.GEWICHTUNGSFAKTOR,
        this.RM_STRICH
      ];
    }

  }
 